module.exports = __webpack_public_path__ + "static/media/mobile_payment.46cfc404.png";